import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { registerUpdates } from './pwa/registerUpdates';
import './ui/styles.css';

const container = document.getElementById('root');
if (!container) throw new Error('Missing #root element');

// Which build is actually executing, readable without opening a menu — by a person
// inspecting the page, and by the update e2e test, whose whole question is whether the
// code running after a deploy is the new code.
document.documentElement.dataset.build = __BUILD_ID__;

// Before the tree renders: an update that is already waiting should be applied while the
// phase is still `loading`, which is what makes it invisible to the player.
registerUpdates();

if (import.meta.env.DEV) {
  void import('./debug').then(({ exposeDebugHandles }) => exposeDebugHandles());
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
